(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider
                .state("Home.Tools.MarketingTracker.Summary.Cumulative",
                    {
                        url: "/Cumulative",
                        component: "cumulative",
                        PageTitle: "Marketing Tracker Summary - Cumulative",
                        resolve: {
                            token: [
                                "marketingTrackerToken", function (marketingTrackerToken) {
                                    return marketingTrackerToken;
                                }
                            ]
                        }
                    });
        }
    ]);

    app
        .component("cumulative",
            {
                templateUrl: "App/Tools/MarketingTracker/Summary/Cumulative/cumulative-template.html",
                controller: cumulativeController,
                bindings: {
                    year: "<",
                    user: "<",
                    onGetUserEvents: "&",
                    twelveMonths: "<",
                    onGetDoughnuts: "&",
                    eventTypes: "<"
                }
            });

    cumulativeController.$inject = ["$q", "userApi"];
    function cumulativeController($q, userApi) {
        var $ctrl = this;

        $ctrl.resetObjects = function () {
            var eventTypeModel = {
                //EventCategory: eventTypeName,
                TotalKeptAppointments: {
                    Referrals: 0,
                    Clients: 0,
                    Prospects: 0,
                    Total: 0
                },
                TotalAppointmentsSet: {
                    Referrals: 0,
                    Clients: 0,
                    Prospects: 0,
                    Total: 0
                },
                TotalClosedAppointments: {
                    Referrals: 0,
                    Clients: 0,
                    Prospects: 0,
                    Total: 0
                },
                TotalLeadsShowed: {
                    Referrals: 0,
                    Clients: 0,
                    Prospects: 0,
                    Total: 0
                },
                Attendees: {
                    Referrals: 0,
                    Clients: 0,
                    Prospects: 0,
                    Total: 0
                },
                Reservations: {
                    Referrals: 0,
                    Clients: 0,
                    Prospects: 0,
                    Total: 0
                },
                Invites: 0,
                TotalCommissionsGenerated: 0,
                TotalSpentOnEvents: 0,
                TotalBusinessClosed: 0,
                TotalEvents: 0,
                ResponseRate: 0,
                NoShowRate: 0,
                AppointmentSettingRate: 0,
                PersistencyRate: 0,
                CloseRate: 0,
                Roi: 0
            };

            $ctrl.Summary = {
                TotalSpentOnEvents: 0,
                TotalBusinessClosed: 0,
                TotalCommissionsGenerated: 0,
                TotalLeadsShowed: 0,
                TotalAppointmentsSet: 0,
                TotalKeptAppointments: 0,
                TotalClosedAppointments: 0,
                TotalAvgCaseSize: 0,
                AvgROI: 0,
                AvgAptSettingRate: 0,
                AvgAptPersistencyRate: 0,
                AvgCloseRate: 0,
                Events: {
                    ClientEvents: ng.copy(eventTypeModel),
                    CollegeCourses: ng.copy(eventTypeModel),
                    DinnerSeminars: ng.copy(eventTypeModel),
                    SSSeminars: ng.copy(eventTypeModel),
                    Referrals: ng.copy(eventTypeModel)
                }
            };
        };

        $ctrl.$onChanges = function () {
          populatePageData();
        };

        function populatePageData() {
            $ctrl.resetObjects();
            userApi.getFigAuth($ctrl.user.Id).then(function (figAuthUser) {

                getAllEvents(figAuthUser.FigAuthUserId);
            });
        }

        function getAllEvents(figAuthUserId) {
           
            var promises = [];
            promises.push($ctrl.onGetUserEvents({ figAuthUserId: figAuthUserId, eventTypes: $ctrl.eventTypes.ClientEvents.types }));
            promises.push($ctrl.onGetUserEvents({ figAuthUserId: figAuthUserId, eventTypes: $ctrl.eventTypes.CollegeClasses.types }));
            promises.push($ctrl.onGetUserEvents({ figAuthUserId: figAuthUserId, eventTypes: $ctrl.eventTypes.DinnerSeminars.types }));
            promises.push($ctrl.onGetUserEvents({ figAuthUserId: figAuthUserId, eventTypes: $ctrl.eventTypes.SSSeminars.types }));
            promises.push($ctrl.onGetUserEvents({ figAuthUserId: figAuthUserId, eventTypes: $ctrl.eventTypes.Referrals.types }));

            $q.all(promises).then(function (data) {

                ng.forEach(data[0], function (event, key) {
                    assignCumulativeValues(event, $ctrl.eventTypes.ClientEvents.name, $ctrl.Summary.Events.ClientEvents);
                });

                ng.forEach(data[1], function (event, key) {
                    assignCumulativeValues(event, $ctrl.eventTypes.CollegeCourses.name, $ctrl.Summary.Events.CollegeCourses);
                });

                ng.forEach(data[2], function (event, key) {
                    assignCumulativeValues(event, $ctrl.eventTypes.DinnerSeminars.name, $ctrl.Summary.Events.DinnerSeminars);
                });

                ng.forEach(data[3], function (event, key) {
                    assignCumulativeValues(event, $ctrl.eventTypes.SSSeminars.name, $ctrl.Summary.Events.SSSeminars);
                });

                ng.forEach(data[4], function (event, key) {
                    assignCumulativeValues(event, $ctrl.eventTypes.Referrals.name, $ctrl.Summary.Events.Referrals);
                });

                $ctrl.Summary.TotalAvgCaseSize = ($ctrl.Summary.TotalBusinessClosed > 0 && $ctrl.Summary.TotalClosedAppointments > 0)
                    ? ($ctrl.Summary.TotalBusinessClosed / $ctrl.Summary.TotalClosedAppointments)
                    : 0;

                $ctrl.graphData = [$ctrl.Summary.Events.ClientEvents.TotalEvents, $ctrl.Summary.Events.CollegeCourses.TotalEvents, $ctrl.Summary.Events.DinnerSeminars.TotalEvents, $ctrl.Summary.Events.SSSeminars.TotalEvents, $ctrl.Summary.Events.Referrals.TotalEvents];

                var sumOfAvgRoi = 0;
                var sumOfAvgAptSettingRates = 0;
                var sumAvgApptPersistancyRates = 0;
                var sumAvgCloseRate = 0;

                var eventTypes = [
                    $ctrl.Summary.Events.ClientEvents, $ctrl.Summary.Events.CollegeCourses,
                    $ctrl.Summary.Events.DinnerSeminars, $ctrl.Summary.Events.SSSeminars, $ctrl.Summary.Events.Referrals
                ];

                ng.forEach(eventTypes, function (et) {
                    sumOfAvgRoi += et.Roi;
                    sumOfAvgAptSettingRates += et.AppointmentSettingRate;
                    sumAvgApptPersistancyRates += et.PersistencyRate;
                    sumAvgCloseRate += et.CloseRate;
                });

                $ctrl.Summary.AvgROI = sumOfAvgRoi / eventTypes.length;
                $ctrl.Summary.AvgROIa = $ctrl.onGetDoughnuts({ num: $ctrl.Summary.AvgROI });
                $ctrl.Summary.AvgAptSettingRate = sumOfAvgAptSettingRates / eventTypes.length;
                $ctrl.Summary.AvgAptSettingRatea = $ctrl.onGetDoughnuts({ num: $ctrl.Summary.AvgAptSettingRate });
                $ctrl.Summary.AvgAptPersistencyRate = sumAvgApptPersistancyRates / eventTypes.length;
                $ctrl.Summary.AvgAptPersistencyRatea = $ctrl.onGetDoughnuts({ num: $ctrl.Summary.AvgAptPersistencyRate });
                $ctrl.Summary.AvgCloseRate = sumAvgCloseRate / eventTypes.length;
                $ctrl.Summary.AvgCloseRatea = $ctrl.onGetDoughnuts({ num: $ctrl.Summary.AvgCloseRate });

            });
        }

        function assignCumulativeValues(r, eventTypeName, eventTypeModel) {

            //console.log(eventTypeName);

            if (eventTypeName !== "Referrals") {
                //Sum up Summary Values
                $ctrl.Summary.TotalSpentOnEvents += r.TotalEventCost;
                $ctrl.Summary.TotalBusinessClosed += r.TotalBusinessClosed;
                $ctrl.Summary.TotalCommissionsGenerated += r.TotalCommission;
                if (r.UnitsAttended)
                    $ctrl.Summary.TotalLeadsShowed += r.UnitsAttended.Clients +
                        r.UnitsAttended.Prospects +
                        r.UnitsAttended.Referrals;
                if (r.AppointmentsSet)
                    $ctrl.Summary.TotalAppointmentsSet += r.AppointmentsSet.Clients +
                        r.AppointmentsSet.Prospects +
                        r.AppointmentsSet.Referrals;
                if (r.AppointmentsKept)
                    $ctrl.Summary.TotalKeptAppointments += r.AppointmentsKept.Clients +
                        r.AppointmentsKept.Prospects +
                        r.AppointmentsKept.Referrals;
                if (r.AppointmentsClosed)
                    $ctrl.Summary.TotalClosedAppointments += r.AppointmentsClosed.Clients +
                        r.AppointmentsClosed.Prospects +
                        r.AppointmentsClosed.Referrals;
            }

            //Sum up event categories
            eventTypeModel.TotalEvents++;
            if (r.AppointmentsKept) {
                eventTypeModel.TotalKeptAppointments.Referrals += r.AppointmentsKept.Referrals;
                eventTypeModel.TotalKeptAppointments.Clients += r.AppointmentsKept.Clients;
                eventTypeModel.TotalKeptAppointments.Prospects += r.AppointmentsKept.Prospects;
                eventTypeModel.TotalKeptAppointments.Total += r.AppointmentsKept.Referrals + r.AppointmentsKept.Clients + r.AppointmentsKept.Prospects;
            }
            if (r.AppointmentsSet) {
                eventTypeModel.TotalAppointmentsSet.Referrals += r.AppointmentsSet.Referrals;
                eventTypeModel.TotalAppointmentsSet.Clients += r.AppointmentsSet.Clients;
                eventTypeModel.TotalAppointmentsSet.Prospects += r.AppointmentsSet.Prospects;
                eventTypeModel.TotalAppointmentsSet.Total += r.AppointmentsSet.Referrals + r.AppointmentsSet.Clients + r.AppointmentsSet.Prospects;
            }
            if (r.AppointmentsClosed) {
                eventTypeModel.TotalClosedAppointments.Referrals += r.AppointmentsClosed.Referrals;
                eventTypeModel.TotalClosedAppointments.Clients += r.AppointmentsClosed.Clients;
                eventTypeModel.TotalClosedAppointments.Prospects += r.AppointmentsClosed.Prospects;
                eventTypeModel.TotalClosedAppointments.Total += r.AppointmentsClosed.Referrals + r.AppointmentsClosed.Clients + r.AppointmentsClosed.Prospects;
            }
            if (r.UnitsAttended) {
                eventTypeModel.TotalLeadsShowed.Referrals += r.UnitsAttended.Referrals;
                eventTypeModel.TotalLeadsShowed.Clients += r.UnitsAttended.Clients;
                eventTypeModel.TotalLeadsShowed.Prospects += r.UnitsAttended.Prospects;
                eventTypeModel.TotalLeadsShowed.Total += r.UnitsAttended.Referrals + r.UnitsAttended.Clients + r.UnitsAttended.Prospects;
            }
            if (r.Attendees) {
                eventTypeModel.Attendees.Referrals += r.Attendees.Referrals;
                eventTypeModel.Attendees.Clients += r.Attendees.Clients;
                eventTypeModel.Attendees.Prospects += r.Attendees.Prospects;
                eventTypeModel.Attendees.Total += r.Attendees.Referrals + r.Attendees.Clients + r.Attendees.Prospects;
            }
            if (r.Reservations) {
                eventTypeModel.Reservations.Referrals += r.Reservations.Referrals;
                eventTypeModel.Reservations.Clients += r.Reservations.Clients;
                eventTypeModel.Reservations.Prospects += r.Reservations.Prospects;
                eventTypeModel.Reservations.Total += r.Reservations.Referrals + r.Reservations.Clients + r.Reservations.Prospects;
            }
            eventTypeModel.Invites += r.Invites;
            eventTypeModel.TotalCommissionsGenerated += r.TotalCommission;
            eventTypeModel.TotalSpentOnEvents += r.TotalEventCost;
            eventTypeModel.TotalBusinessClosed += r.TotalBusinessClosed;

            //Response Rate
            if (eventTypeName === "Client Events") {
                eventTypeModel.ResponseRate = eventTypeModel.Invites > 0
                    ? (eventTypeModel.Reservations.Total / eventTypeModel.Invites) * 100
                    : 0;
            }

            else if (eventTypeName === "Referrals") {
                eventTypeModel.ResponseRate = eventTypeModel.Invites > 0
                    ? (eventTypeModel.Reservations.Referrals / eventTypeModel.Invites) * 100
                    : 0;
            } else {
                eventTypeModel.ResponseRate = eventTypeModel.Invites > 0
                    ? (eventTypeModel.Reservations.Prospects / eventTypeModel.Invites) * 100
                    : 0;
            }
            if (eventTypeModel.ResponseRate < 0) eventTypeModel.ResponseRate = 0;

            //No Show Rate
            if (eventTypeName === "Referrals") {
                eventTypeModel.NoShowRate = eventTypeModel.Reservations.Referrals > 0 && eventTypeModel.Reservations.Referrals > eventTypeModel.Attendees.Referrals
                    ? ((eventTypeModel.Reservations.Referrals - eventTypeModel.Attendees.Referrals) / eventTypeModel.Reservations.Referrals) * 100
                    : 0;
            } else {
                eventTypeModel.NoShowRate = eventTypeModel.Reservations.Total > 0
                    ? ((eventTypeModel.Reservations.Total - eventTypeModel.Attendees.Total) / eventTypeModel.Reservations.Total) * 100
                    : 0;
            }
            if (eventTypeModel.NoShowRate < 0) eventTypeModel.NoShowRate = 0;

            //Appointment Setting Rate
            if (eventTypeName === "Referrals") {
                eventTypeModel.AppointmentSettingRate = eventTypeModel.TotalLeadsShowed.Total > 0 &&
                    eventTypeModel.TotalAppointmentsSet.Referrals > 0
                    ? (eventTypeModel.TotalAppointmentsSet.Referrals / eventTypeModel.TotalLeadsShowed.Referrals) * 100
                    : 0;
            } else {
                eventTypeModel.AppointmentSettingRate = eventTypeModel.TotalLeadsShowed.Total > 0 &&
                    eventTypeModel.TotalAppointmentsSet.Total > 0
                    ? (eventTypeModel.TotalAppointmentsSet.Total / eventTypeModel.TotalLeadsShowed.Total) * 100
                    : 0;
            }
            if (eventTypeModel.AppointmentSettingRate < 0) eventTypeModel.AppointmentSettingRate = 0;

            //Persistancy Rate
            if (eventTypeName === "Referrals") {
                eventTypeModel.PersistencyRate = eventTypeModel.TotalAppointmentsSet.Referrals > 0 &&
                    eventTypeModel.TotalKeptAppointments.Referrals > 0
                    ? (eventTypeModel.TotalKeptAppointments.Referrals / eventTypeModel.TotalAppointmentsSet.Referrals) * 100
                    : 0;
            } else {
                eventTypeModel.PersistencyRate = eventTypeModel.TotalAppointmentsSet.Total > 0 &&
                    eventTypeModel.TotalKeptAppointments.Total > 0
                    ? (eventTypeModel.TotalKeptAppointments.Total / eventTypeModel.TotalAppointmentsSet.Total) * 100
                    : 0;
            }
            if (eventTypeModel.PersistencyRate < 0) eventTypeModel.PersistencyRate = 0;

            //Close Rate                        
            if (eventTypeName === "Referrals") {
                eventTypeModel.CloseRate = eventTypeModel.TotalKeptAppointments.Referrals > 0 &&
                    eventTypeModel.TotalClosedAppointments.Referrals > 0
                    ? (eventTypeModel.TotalClosedAppointments.Referrals / eventTypeModel.TotalKeptAppointments.Referrals) * 100
                    : 0;
            } else {
                eventTypeModel.CloseRate = eventTypeModel.TotalKeptAppointments.Total > 0 &&
                    eventTypeModel.TotalClosedAppointments.Total > 0
                    ? (eventTypeModel.TotalClosedAppointments.Total / eventTypeModel.TotalKeptAppointments.Total) * 100
                    : 0;
            }
            if (eventTypeModel.CloseRate < 0) eventTypeModel.CloseRate = 0;

            //ROI
            eventTypeModel.Roi = eventTypeModel.TotalCommissionsGenerated > 0 && eventTypeModel.TotalCommissionsGenerated > eventTypeModel.TotalSpentOnEvents
                ? ((eventTypeModel.TotalCommissionsGenerated - eventTypeModel.TotalSpentOnEvents) / eventTypeModel.TotalSpentOnEvents) *
                100
                : 0;
            if (eventTypeModel.Roi < 0) eventTypeModel.Roi = 0;

            return eventTypeModel;
        }
    }
})(window.app, window.angular); //jshint ignore:line